/**
 * Decide whether a Home page "Delete Project" action should remove the whole
 * project or only the tasks currently visible under active filters/search.
 *
 * `filteredApp` is the project as rendered (from `filteredApps`);
 * `unfilteredApp` is the same project from `allApps`.
 */

export const flattenProjectUsecases = (app) =>
    (app?.sub_groups || []).flatMap((subGroup) => subGroup.usecases || []).filter((usecase) => usecase?._id);

export const projectTaskCardCount = (app) => (app?.sub_groups || []).length;

export const getProjectDeleteScope = (filteredApp, unfilteredApp) => {
    const visibleUsecases = flattenProjectUsecases(filteredApp);
    const allUsecases = flattenProjectUsecases(unfilteredApp);
    const visibleIds = new Set(visibleUsecases.map((usecase) => String(usecase._id)));
    const hasHiddenTasks = allUsecases.some((usecase) => !visibleIds.has(String(usecase._id)));
    const isFilteredDelete = hasHiddenTasks && visibleUsecases.length > 0;

    return {
        mode: isFilteredDelete ? 'filtered-tasks' : 'project',
        usecases: visibleUsecases,
        visibleTaskCount: projectTaskCardCount(filteredApp),
        totalTaskCount: projectTaskCardCount(unfilteredApp),
    };
};

export const resolveProjectDeleteScope = (filteredApp, allApps) => {
    const unfilteredApp = (allApps || []).find((app) => app.group_name === filteredApp?.group_name);
    return getProjectDeleteScope(filteredApp, unfilteredApp);
};
